import React from "react";
import { Icon } from "@vitalsource/vstui";

class Search extends React.PureComponent {
  render() {
    return (
      <Icon {...this.props} height={22} width={22}>
        <path
          d="M2 9c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7m14.613 4.785A8.945 8.945 0 0 0 18 9a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9c1.76 0 3.398-.513 4.785-1.387l4.801 4.801a2 2 0 1 0 2.828-2.828l-4.801-4.8z"
          fill="#FFF"
        />
      </Icon>
    );
  }
}

Search.displayName = "Search";
Search.vstuiName = "Icon";

export default Search;
